import { FC } from 'react';
import './Switcher.css';

interface SwitcherProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    disabled?: boolean;
}

export const Switcher: FC<SwitcherProps> = ({ checked, onChange, label, disabled }) => {
    return (
        <label className={`switcher${disabled ? ' switcher--disabled' : ''}`}>
            <input
                type="checkbox"
                className="switcher__input"
                checked={checked}
                onChange={e => onChange(e.target.checked)}
                disabled={disabled}
            />
            <span className="switcher__track">
                <span className="switcher__knob" />
            </span>
            {label && <span className="switcher__label">{label}</span>}
        </label>
    );
};
